const showDependsOnTwoFlags = (flags, show, hide) => {
    return flags?.get(show) && !flags?.get(hide);
};

export { showDependsOnTwoFlags };
